export function pushToDataLayer(event: string, data?: Record<string, unknown>) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...data,
  });
}

export function trackPageView(path: string, title?: string) {
  pushToDataLayer('page_view', {
    page_path: path,
    page_title: title || document.title,
  });
}
